import React, { useEffect, useState } from 'react';
import classes from "./ConfirmationPage2.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { confirmSubAPI, loginApi } from '../../http/http';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa6';
import { setUserDetails } from '../../store/slices/userSlice';
import { setLanguage } from '../../store/slices/languageSlice';
import i18n from '../../locales/i18n';
import SmallLoader from '../../component/SmallLoader';

const ConfirmationPage2 = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState(null);
    const [extRef, setExtRef] = useState(null);
    const [pack, setPack] = useState(null);
    const [packNo, setPackNo] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    const { t } = useTranslation();

    useEffect(() => {
        if (selectedLanguage && i18n.language !== selectedLanguage) {
            i18n.changeLanguage(String(selectedLanguage));
        }
    }, [selectedLanguage, i18n]);

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setPack(location?.state?.pack);
            setPackNo(location?.state?.packNo);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);

            const response = await confirmSubAPI(msisdn, extRef, pack);
            setLoading(false);

            if (response?.data?.status == 4) {
                toast.success(t("243"));
            }

            if (response?.data?.status == 3) {
                navigate("/low-balance");
                return;
            }

            await loginApi(msisdn)
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserDetails(res?.data?.result));
                    navigate("/home", { replace: true, state: null });
                    toast.success(t("21"));
                })
                .catch((err) => {
                    setLoading(false);

                    if (err?.response?.data?.error?.status == 1) {
                        navigate("/low-balance");
                    }
                    else {
                        toast.error(t("20"));
                    }

                });
        } catch (error) {
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("244"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("245"));
            }
            else {
                toast.error(t("20"));
            }
        }
    }

    return (
        <div className={classes.page}>

            <select
                id="lang"
                name="lang"
                className={classes.dropdown}
                value={selectedLanguage}
                onChange={(event) => {
                    dispatch(setLanguage(event.target.value));
                }}
            >
                <option value="0">English</option>
                <option value="1">French</option>
            </select>

            {/* ══ LEFT — Brand Hero ══ */}
            <div className={classes.leftPanel}>
                <div className={classes.arcCircle} />

                {/* Logo */}
                {/* <div className={classes.logo}>
                    <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
                </div> */}

                <div className={classes.container}>
                    <h2 className={classes.title}>{t("236")}</h2>
                    <p className={classes.text}>
                        {t("237")} <span className={classes.bold}>{packNo == "50" ? t("238") : t("239")}</span>.{" "}
                        {t("240")}
                    </p>

                    <div className={classes.buttons_container}>
                        <button type='button' disabled={loading} className={classes.button} onClick={handleFormSubmission}>
                            {loading ? <SmallLoader /> : t("241")}
                        </button>
                        <button type='button' disabled={loading} className={classes.no_button} onClick={() => navigate("/")}>
                            {t("242")}
                        </button>
                    </div>


                </div>

            </div>

            <div className={classes.copyrightFooter}>
                <div className={classes.copyrightDivider} />
                <div className={classes.copyrightInner}>
                    <span className={classes.copyrightBadge}>
                        <span className={classes.copyrightBadgeIcon}>⚽</span>
                        Football Masters
                    </span>
                    <p className={classes.copyrightText}>
                        © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                    </p>
                    <p className={classes.copyrightSub}>All rights reserved</p>
                </div>
            </div>

        </div>
    )
}

export default ConfirmationPage2